import Maria from "../media/people/Maria.jpeg";
import Nerea from "../media/people/Nerea.jpeg";
import Rahmi from "../media/people/Rahmi.jpeg";
import Will from "../media/people/Will.jpeg";
import abigail from "../media/people/abigail.jpeg";
import abril from "../media/people/abril.jpeg";
import amy from "../media/people/amy.jpeg";
import andy from "../media/people/andy.jpeg";
import ansley from "../media/people/ansley.png";
import athina from "../media/people/athina.png";
import chris from "../media/people/chris.jpeg";
import daniela from "../media/people/daniela.jpeg";
import drew from "../media/people/drew.jpeg";
import egle from "../media/people/egle.jpeg";
import eugene from "../media/people/eugene.jpeg";
import giovanna from "../media/people/giovanna.jpeg";
import hilary from "../media/people/hilary.jpeg";
import ieva from "../media/people/ieva.jpeg";
import jionglin from "../media/people/jionglin.jpeg";
import john from "../media/people/john.jpeg";
import kamile from "../media/people/kamile.jpeg";
import kelly from "../media/people/kelly.jpeg";
import kevin from "../media/people/kevin.jpeg";
import mariana from "../media/people/mariana.jpeg";
import nannan from "../media/people/nannan.jpeg";
import ricardo from "../media/people/ricardo.jpeg";
import shrestha from "../media/people/shrestha.jpg";
import srishty from "../media/people/srishty.jpeg";
import tijn from "../media/people/tijn.jpeg";
import todd from "../media/people/todd.jpeg";
import varun from "../media/people/varun.jpeg";
import vinca from "../media/people/vinca.jpeg";
import wilson from "../media/people/wilson.jpeg";
import youssef from "../media/people/youssef.jpg";
import Alejandro from "../media/people/Alejandro.jpg";
import ChengKai from "../media/people/ChengKai.jpg";
import Daniel from "../media/people/Daniel.jpg";
import Dorothy from "../media/people/Dorothy.jpg";
import Douglas from "../media/people/Douglas.jpg";
import Hana from "../media/people/Hana.jpg";
import Justine from "../media/people/Justine.jpg";
import Marjolein from "../media/people/Marjolein.jpg";
import Marsad from "../media/people/Marsad.jpg";
import Meagan from "../media/people/Meagan.jpg";
import Nemanja from "../media/people/Nemanja.jpg";
import Piers from "../media/people/Piers.jpg";
import Randy from "../media/people/Randy.jpg";
import Rene from "../media/people/Rene.jpg";
import Tessa from "../media/people/Tessa.jpg";
import Traci from "../media/people/Traci.jpg";
import Varsha from "../media/people/Varsha.jpg";
import Vinoo from "../media/people/Vinoo.jpg";
import amyzhang from "../media/people/amyzhang.jpg";
import janine from "../media/people/janine.jpg";
import megan from "../media/people/megan.jpg";
import paulius from "../media/people/paulius.jpg";
import Alex from "../media/people/Alex.png";
import alonso from "../media/people/alonso.png";
import carolina from "../media/people/carolina.png";
import guilherme from "../media/people/guilherme.png";
import heber from "../media/people/heber.png";
import paul from "../media/people/paul.png";
import zeeshan from "../media/people/zeeshan.png";
import mia from "../media/people/mia.png";

import adam from "../media/people/adam.jpg";
import adelia from "../media/people/adelia.jpeg";
import barbora from "../media/people/barbora.png";
import cindy from "../media/people/cindy.jpeg";
import fahmi from "../media/people/fahmi.jpeg";
import franka from "../media/people/franka.jpeg";
import indah from "../media/people/indah.jpeg";
import mochammad from "../media/people/mochammad.jpg";
import muhammad from "../media/people/muhammad.jpeg";
import philipp from "../media/people/philipp.jpeg";
import kristin from "../media/people/kristin.jpeg";
import rian from "../media/people/rian.jpg";
import ronit from "../media/people/ronit.jpeg";
import allyssa from "../media/people/allyssa.png";

import afterigem_white from "../media/logos/afterigem_white.svg";
import epic_white from "../media/logos/epic_white.svg";
import igem_white from "../media/logos/igem_white.svg";
import igemdesign_white from "../media/logos/igemdesign_white.svg";
import alumni from "../media/logos/alumni.svg";
import idt from "../media/logos/idt.svg";

import Australia from "../media/flags/australia.png";
import brazil from "../media/flags/brazil.png";
import canada from "../media/flags/canada.png";
import china from "../media/flags/china.png";
import Denmark from "../media/flags/denmark.png";
import egypt from "../media/flags/egypt.png";
import France from "../media/flags/france.png";
import Germany from "../media/flags/germany.png";
import india from "../media/flags/india.png";
import lithuania from "../media/flags/lithuania.png";
import mexico from "../media/flags/mexico.png";
import Montenegro from "../media/flags/montenegro.png";
import netherlands from "../media/flags/netherlands.png";
import Singapore from "../media/flags/singapore.png";
import Spain from "../media/flags/spain.png";
import uk from "../media/flags/uk.png";
import us from "../media/flags/us.png";
import greece from "../media/flags/greece.png";
import uganda from "../media/flags/uganda.png";
import norway from "../media/flags/norway.png";
import sweden from "../media/flags/sweden.png";
import indonesia from "../media/flags/indonesia.png";
import czech from "../media/flags/czech.png";

export const hosts = [
  {
    id: 11,
    name: "Carolina Elizondo",
    image: carolina,
    title: "Global Ambassador Program Coordinator",
    filters: ["iGEM Staff, Alumni, Host"],
    organization: "After iGEM",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/mcelizondo/",
  },
  {
    id: 22,
    name: "Guilherme Kundlatsch",
    image: guilherme,
    title: "iGEM Producer",
    filters: ["iGEM Staff", "Alumni", "Host"],
    organization: "iGEM Foundation",
    region: "Latin America",
    country: "Brazil",
    flag: brazil,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/guilherme-kundlatsch-8940a5132/",
  },
  {
    id: 64,
    name: "Zeeshan Siddiqui",
    image: zeeshan,
    title: "Director of Digital Science Journalism",
    filters: ["iGEM Staff", "Alumni", "Host"],
    organization: "iGEM Foundation",
    region: "Asia",
    country: "Australia",
    flag: Australia,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/zeeshan-siddiqui-464ab9130/",
  },
];

export const guests = [
  {
    id: 1,
    name: "Abigail Conner",
    image: abigail,
    title: "Ambassador to Europe",
    filters: ["Ambassador", "Alumni"],
    organization: "KCL UK 2020",
    region: "Europe",
    country: "United Kingdom",
    flag: uk,
    logo: afterigem_white,
    sessionId: 5,
    linkedIn: "https://www.linkedin.com/in/abigail-conner227/",
  },
  {
    id: 2,
    name: "Abril Diosdado Hernandez",
    image: abril,
    title: "Ambassador to Latin America",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: afterigem_white,
    sessionId: 4,
    linkedIn: "https://www.linkedin.com/in/abrildh/",
  },
  {
    id: 3,
    name: "Alejandro Vignoni",
    image: Alejandro,
    title: "Associate Professor",
    filters: ["Volunteer Committees"],
    organization: "Universitat Politècnica de València",
    region: "Europe",
    country: "Spain",
    flag: Spain,
    logo: undefined,
    sessionId: 8,
    linkedIn: "https://www.linkedin.com/in/alejovigno/",
  },
  {
    id: 4,
    name: "Alex Kyabarongo",
    image: Alex,
    title: "African Ambassador Coordinator",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Africa",
    country: "Uganda",
    flag: uganda,
    logo: afterigem_white,
    sessionId: 3,
    linkedIn: "https://www.linkedin.com/in/alex-kyabarongo-18707b171/",
  },
  {
    id: 5,
    name: "Alonso Flores",
    image: alonso,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "FCB UANL 2019-2020",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: alumni,
    sessionId: 5,
    linkedIn:
      "https://www.linkedin.com/in/alonso-flores-b9b66318a/?trk=public_profile_browsemap_profile-result-card_result-card_full-click&originalSubdomain=be",
  },
  {
    id: 6,
    name: "Amy Yeung",
    image: amy,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "canadianGEM 2020",
    region: "North America",
    country: "Canada",
    flag: canada,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/bi-ru-amy-yeung-116622162/",
  },
  {
    id: 7,
    name: "Amy Zhang",
    image: amyzhang,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Euroasian Meetup 2018",
    region: "Asia",
    country: "China",
    flag: china,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/qinming-zhang-b48b46195/",
  },
  {
    id: 8,
    name: "Andy Halleran",
    image: andy,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "William & Mary 2015",
    region: "North America",
    country: "United States",
    flag: us,
    logo: undefined,
    sessionId: 18,
    linkedIn: "",
  },
  {
    id: 9,
    name: "Ansley Gnanapragasam",
    image: ansley,
    title: "North American Ambassador Coordinator",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "North America",
    country: "United States",
    flag: us,
    logo: afterigem_white,
    sessionId: 3,
    linkedIn: "https://www.linkedin.com/in/ansley-gnanapragasam-7a525995/",
  },
  {
    id: 10,
    name: "Athina Milona",
    image: athina,
    title: "European Ambassador Coordinator",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Europe",
    country: "Greece",
    flag: greece,
    logo: afterigem_white,
    sessionId: 3,
    linkedIn: "https://www.linkedin.com/in/athina-milona-a0b58119a/",
  },
  {
    id: 12,
    name: "Cheng Kai Lim",
    image: ChengKai,
    title: "EPIC Chair",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM EPIC",
    region: "Asia",
    country: "Singapore",
    flag: Singapore,
    logo: epic_white,
    sessionId: 11,
    linkedIn: "https://www.linkedin.com/in/cheng-kai-lim/",
  },
  {
    id: 13,
    name: "Chris Kuffner",
    image: chris,
    title: "Steering Group of Education Network",
    filters: ["Volunteer Committees", "Alumni"],
    organization: "After iGEM",
    region: "North America",
    country: "United States",
    flag: us,
    logo: afterigem_white,
    sessionId: 23,
    linkedIn: "https://www.linkedin.com/in/chris-kuffner-b9a316115/",
  },
  {
    id: 14,
    name: "Daniel Dominguez",
    image: Daniel,
    title: "Head of Partnerships",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Design League",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: igemdesign_white,
    sessionId: 9,
    linkedIn: "https://www.linkedin.com/in/daniel-dominguez-gomez/",
  },
  {
    id: 15,
    name: "Daniela Alvarez-Robledo",
    image: daniela,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "HISPAM Online Meetup 2020",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/danielaalvvarez/",
  },
  {
    id: 16,
    name: "Dorothy Zhang",
    image: Dorothy,
    title: "Director of Community Engagement",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM",
    region: "Europe",
    country: "France",
    flag: France,
    logo: igem_white,
    sessionId: "3,29",
    linkedIn: "https://www.linkedin.com/in/dorothy-zhang-50753733/",
  },
  {
    id: 17,
    name: "Doug Densmore",
    image: Douglas,
    title: "Co-Founder",
    filters: ["iGEM Friends"],
    organization: "Asimov Inc.",
    region: "North America",
    country: "United States",
    flag: us,
    logo: undefined,
    sessionId: 10,
    linkedIn: "https://www.linkedin.com/in/douglas-densmore-0852243/",
  },
  {
    id: 18,
    name: "Drew Endy",
    image: drew,
    title: "iGEM Co-founder, Associate Chair of Bioengineering",
    filters: ["iGEM Friends"],
    organization: "Stanford University, Biobricks Foundation",
    region: "North America",
    country: "United States",
    flag: us,
    logo: undefined,
    sessionId: 25,
    linkedIn: "",
  },
  {
    id: 19,
    name: "Eglė Vitkūnaitė",
    image: egle,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Vilnius-Lithuania 2020",
    region: "Europe",
    country: "Lithuania",
    flag: lithuania,
    logo: alumni,
    sessionId: 18,
    linkedIn:
      "https://www.linkedin.com/in/egl%C4%97-vitk%C5%ABnait%C4%97-601b881b8/",
  },
  {
    id: 20,
    name: "Eugene Golov",
    image: eugene,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Leiden 2020",
    region: "Europe",
    country: "Netherlands",
    flag: netherlands,
    logo: alumni,
    sessionId: 6,
    linkedIn: "https://www.linkedin.com/in/eugenegolov/",
  },
  {
    id: 21,
    name: "Giovanna Maklouf",
    image: giovanna,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "UFAM-UEA 2016, Amazonas_Brazil 2017 & 2019",
    region: "Latin America",
    country: "Brazil",
    flag: brazil,
    logo: alumni,
    sessionId: 4,
    linkedIn: "https://www.linkedin.com/in/giovannamaklouf/",
  },
  {
    id: 23,
    name: "Hana Abdelzaher",
    image: Hana,
    title: "EPIC Wildtype",
    filters: ["Alumni"],
    organization: "iGEM EPIC",
    region: "Africa",
    country: "Egypt",
    flag: egypt,
    logo: epic_white,
    sessionId: 22,
    linkedIn: "https://www.linkedin.com/in/hana-abdelzaher/",
  },
  {
    id: 24,
    name: "Heber Torres",
    image: heber,
    title: "Latin American Ambassador Coordinator",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: afterigem_white,
    sessionId: 3,
    linkedIn: "https://www.linkedin.com/in/heber-m-torres-cordero-298456124/",
  },
  {
    id: 25,
    name: "Hilary Sutcliffe",
    image: hilary,
    title: "Director",
    filters: ["iGEM Friends"],
    organization: "SocietyInside",
    region: "Europe",
    country: "United Kingdom",
    flag: uk,
    logo: undefined,
    sessionId: 16,
    linkedIn: "",
  },
  {
    id: 26,
    name: "Ieva Lingytė",
    image: ieva,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Vilnius-Lithuania 2020",
    region: "Europe",
    country: "Lithuania",
    flag: lithuania,
    logo: alumni,
    sessionId: 18,
    linkedIn: "https://www.linkedin.com/in/ieva-lingyt%C4%97-54a133181/",
  },
  {
    id: 27,
    name: "Janine Wanke",
    image: janine,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "German Online Meetup 2020",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 28,
    name: "Jionglin Chen",
    image: jionglin,
    title: "iGEM Alumni & General Secretary",
    filters: ["Alumni"],
    organization: "CCiC (Conference of China iGEMer Community)",
    region: "Asia",
    country: "China",
    flag: china,
    logo: alumni,
    sessionId: 21,
    linkedIn: "",
  },
  {
    id: 29,
    name: "John Marken",
    image: john,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "William & Mary 2015",
    region: "North America",
    country: "United States",
    flag: us,
    logo: alumni,
    sessionId: 18,
    linkedIn: "",
  },
  {
    id: 30,
    name: "Justine Salazar",
    image: Justine,
    title: "Video Producer",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Foundation",
    region: "Asia",
    country: "Australia",
    flag: Australia,
    logo: igem_white,
    sessionId: 17,
    linkedIn: "https://www.linkedin.com/in/jvsalazar/",
  },
  {
    id: 31,
    name: "Kamilė Vainiūtė",
    image: kamile,
    title: "iGEM Alumni",
    filters: ["Alumni", "iGEM Staff"],
    organization: "Vilnius-Lithuania 2020",
    region: "Europe",
    country: "Lithuania",
    flag: lithuania,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/kamile-liucija-vainiute/",
  },
  {
    id: 32,
    name: "Kelly Yang",
    image: kelly,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "TAS-Taipei 2020",
    region: "Asia",
    country: "Taiwan*",
    flag: undefined,
    logo: alumni,
    sessionId: 6,
    linkedIn: "",
  },
  {
    id: 33,
    name: "Kevin Chen",
    image: kevin,
    title: "Co-Chair",
    filters: ["Volunteer Committees"],
    organization: "Human Practices Committee",
    region: "North America",
    country: "Canada",
    flag: canada,
    logo: alumni,
    sessionId: 16,
    linkedIn: "https://www.linkedin.com/in/bkevinchen/",
  },
  {
    id: 34,
    name: "Maria Astolfi",
    image: Maria,
    title: "Strain Engineer at Gingko, Education Coordinator",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Design League",
    region: "Latin America",
    country: "Brazil",
    flag: brazil,
    logo: igemdesign_white,
    sessionId: 9,
    linkedIn: "https://www.linkedin.com/in/synbiomaria/",
  },
  {
    id: 35,
    name: "Mariana Cesar",
    image: mariana,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "AQA Unesp 2017, Unesp Brazil 2018",
    region: "Latin America",
    country: "Brazil",
    flag: brazil,
    logo: alumni,
    sessionId: 4,
    linkedIn: "https://www.linkedin.com/in/mariana-biondi-cesar-820003143/",
  },
  {
    id: 36,
    name: "Marjolein Croijmans",
    image: Marjolein,
    title: "EPIC Co-Chair",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM EPIC",
    region: "Europe",
    country: "Netherlands",
    flag: netherlands,
    logo: epic_white,
    sessionId: 11,
    linkedIn: "https://www.linkedin.com/in/marjolein-crooijmans/",
  },
  {
    id: 37,
    name: "Meagan Lizarazo",
    image: Meagan,
    title: "Executive Vice President",
    filters: ["iGEM Staff"],
    organization: "iGEM Foundation",
    region: "North America",
    country: "United States",
    flag: us,
    logo: igem_white,
    sessionId: 1,
    linkedIn: "https://www.linkedin.com/in/meaganlizarazo/",
  },
  {
    id: 38,
    name: "Megan Palmer",
    image: megan,
    title: "Executive Director of Biopolicy & Leadership Initiatives",
    filters: ["iGEM Friends"],
    organization: "Stanford University",
    region: "North America",
    country: "United States",
    flag: us,
    logo: undefined,
    sessionId: 26,
    linkedIn: "https://www.linkedin.com/in/meganjpalmer/",
  },
  {
    id: 39,
    name: "Mia Wang",
    image: mia,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "GreatBay SZ 2019",
    region: "Asia",
    country: "China",
    flag: china,
    logo: alumni,
    sessionId: 20,
    linkedIn: "",
  },
  {
    id: 40,
    name: "Mohammad Marsad Siddique",
    image: Marsad,
    title: "iGEM Alumni",
    filters: ["Volunteer Committees", "Alumni"],
    organization: "LACAS 2017-2018",
    region: "Europe",
    country: "France",
    flag: France,
    logo: alumni,
    sessionId: 20,
    linkedIn: "https://www.linkedin.com/in/marsad-siddique-47390719a/",
  },
  {
    id: 41,
    name: "Nannan Jiang",
    image: nannan,
    title: "Education & Outreach Officer",
    filters: ["Volunteer Committees", "Alumni"],
    organization: "After iGEM",
    region: "North America",
    country: "United States",
    flag: us,
    logo: afterigem_white,
    sessionId: 23,
    linkedIn: "https://www.linkedin.com/in/nannanjiang1/",
  },
  {
    id: 42,
    name: "Nemanja Stijepovic",
    image: Nemanja,
    title: "Vice President of Creative Productions",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Foundation",
    region: "Europe",
    country: "Montenegro",
    flag: Montenegro,
    logo: igem_white,
    sessionId: 29,
    linkedIn: "https://www.linkedin.com/in/nemanjastijepovic/",
  },
  {
    id: 43,
    name: "Nerea Capon Lamelas",
    image: Nerea,
    title: "Global Alliance Project Manager",
    filters: ["iGEM Staff", "Alumni"],
    organization: "After iGEM",
    region: "Europe",
    country: "Sweden",
    flag: sweden,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/nereacapon/",
  },
  {
    id: 44,
    name: "Paul James",
    image: paul,
    title: "Chair",
    filters: ["Volunteer Committees"],
    organization: "Judging Corps Committee",
    region: "Europe",
    country: "United Kingdom",
    flag: uk,
    logo: undefined,
    sessionId: 22,
    linkedIn: "https://www.linkedin.com/in/paul-james-60657a94/",
  },
  {
    id: 45,
    name: "Paulius Sasnauskas",
    image: paulius,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Vilnius-Lithuania 2020",
    region: "Europe",
    country: "Lithuania",
    flag: lithuania,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/pauliussasnauskas/",
  },
  {
    id: 46,
    name: "Piers Millett",
    image: Piers,
    title: "Vice President of Safety & Security",
    filters: ["iGEM Staff"],
    organization: "iGEM Foundation",
    region: "Europe",
    country: "United Kingdom",
    flag: uk,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/pdmillett/",
  },
  {
    id: 47,
    name: "Rahmi Lale",
    image: Rahmi,
    title: "CEO of Syngens AS",
    filters: ["Alumni"],
    organization: "Norwegian University of Science and Technology",
    region: "Europe",
    country: "Norway",
    flag: norway,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 48,
    name: "Randy Rettberg",
    image: Randy,
    title: "President & Co-Founder",
    filters: ["iGEM Staff"],
    organization: "iGEM Foundation",
    region: "North America",
    country: "United States",
    flag: us,
    logo: igem_white,
    sessionId: 1,
    linkedIn: "",
  },
  {
    id: 49,
    name: "Rene Inckemann",
    image: Rene,
    title: "iGEM Alumni",
    filters: ["Volunteer Committees", "Alumni"],
    organization: "Marburg 2018",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: 8,
    linkedIn: "https://www.linkedin.com/in/ren%C3%A9-inckemann-6a6ab913b/",
  },
  {
    id: 50,
    name: "Ricardo Chavez",
    image: ricardo,
    title: "Vice President of Latin American Operations",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Foundation",
    region: "Latin America",
    country: "Mexico",
    flag: mexico,
    logo: igemdesign_white,
    sessionId: 9,
    linkedIn: "https://www.linkedin.com/in/ricardochavezmtz/",
  },
  {
    id: 51,
    name: "Shrestha Rath",
    image: shrestha,
    title: "Asian Ambassador Coordinator",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Asia",
    country: "India",
    flag: india,
    logo: afterigem_white,
    sessionId: 3,
    linkedIn: "https://www.linkedin.com/in/shresrath/",
  },
  {
    id: 52,
    name: "Srishty Rathee",
    image: srishty,
    title: "Ambassador to Europe, Organizer",
    filters: ["Ambassador", "Alumni"],
    organization: "iGEM Spring Festival 2019",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: afterigem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/srishty-rathee-0502b0163/",
  },
  {
    id: 53,
    name: "Tessa Alexanian",
    image: Tessa,
    title: "Safety & Security Program Officer",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Foundation",
    region: "North America",
    country: "Canada",
    flag: canada,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/tessaalexanian/",
  },
  {
    id: 54,
    name: "Tijn Delzenne",
    image: tijn,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Leiden 2020",
    region: "Europe",
    country: "Netherlands",
    flag: netherlands,
    logo: alumni,
    sessionId: 6,
    linkedIn: "https://www.linkedin.com/in/tijn-delzenne-2486bb176/",
  },
  {
    id: 55,
    name: "Todd Kuiken",
    image: todd,
    title: "Senior Research Scholar",
    filters: ["Volunteer Committees"],
    organization: "North Carolina University",
    region: "North America",
    country: "United States",
    flag: us,
    logo: undefined,
    sessionId: 7,
    linkedIn: "https://www.linkedin.com/in/drtoddkuiken/",
  },
  {
    id: 56,
    name: "Traci Haddock-Angeli",
    image: Traci,
    title: "Director of the Competition",
    filters: ["iGEM Staff"],
    organization: "iGEM Foundation",
    region: "North America",
    country: "United States",
    flag: us,
    logo: igem_white,
    sessionId: "5,19",
    linkedIn: "https://www.linkedin.com/in/tracihaddock/",
  },
  {
    id: 57,
    name: "Varsha Jaisimha",
    image: Varsha,
    title: "After iGEM Coordinator",
    filters: ["iGEM Staff", "Alumni"],
    organization: "After iGEM",
    region: "Asia",
    country: "India",
    flag: india,
    logo: igem_white,
    sessionId: 8,
    linkedIn: "https://www.linkedin.com/in/varsha-jaisimha/",
  },
  {
    id: 58,
    name: "Varun Govil",
    image: varun,
    title: "iGEM Alumni, Co Founder & CEO",
    filters: ["Alumni"],
    organization: "Epinoma",
    region: "North America",
    country: "United States",
    flag: us,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/varun-govil/",
  },
  {
    id: 59,
    name: "Vinca Seiler",
    image: vinca,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "German Online Meetup 2020",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 60,
    name: "Vinoo Selvarajah",
    image: Vinoo,
    title: "Director of the Registry",
    filters: ["iGEM Staff"],
    organization: "iGEM Foundation",
    region: "North America",
    country: "United States",
    flag: us,
    logo: igem_white,
    sessionId: 25,
    linkedIn: "",
  },
  {
    id: 61,
    name: "Will Wright",
    image: Will,
    title: "Director of Entrepreneurship",
    filters: ["iGEM Staff", "Alumni"],
    organization: "iGEM Foundation",
    region: "Europe",
    country: "Denmark",
    flag: Denmark,
    logo: igem_white,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/willwright1/",
  },
  {
    id: 62,
    name: "Wilson Huang",
    image: wilson,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "TAS-Taipei 2020",
    region: "Asia",
    country: "Taiwan*",
    flag: undefined,
    logo: alumni,
    sessionId: 6,
    linkedIn: "",
  },
  {
    id: 63,
    name: "Youssef Abdelmaksoud",
    image: youssef,
    title: "Ambassador to Africa",
    filters: ["Ambassador", "Alumni"],
    organization: "After iGEM",
    region: "Africa",
    country: "Egypt",
    flag: egypt,
    logo: afterigem_white,
    sessionId: 12,
    linkedIn: "https://www.linkedin.com/in/youssef--mahmoud/",
  },
  {
    id: 65,
    name: "Franka Eiche",
    image: franka,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "TU Darmstadt 2020",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 66,
    name: "Philipp Becker",
    image: philipp,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "TU Darmstadt 2020",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 67,
    name: "Allyssa Hinkle",
    image: allyssa,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "TU Kaiserslautern",
    region: "Europe",
    country: "Germany",
    flag: Germany,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 68,
    name: "Barbora Hrnčířová",
    image: barbora,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Brno Czech Republic 2020",
    region: "Europe",
    country: "Czech Republic",
    flag: czech,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 69,
    name: "Kristin Ellis",
    image: kristin,
    title: "iGEM Alumni, Entrepreneur in residence",
    filters: ["Alumni"],
    organization: "Carbon180",
    region: "North America",
    country: "United States",
    flag: us,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 70,
    name: "Adam Clore",
    image: adam,
    title: "Director of Development, Synthetic Biology",
    filters: ["iGEM Friends"],
    organization: "Integrated DNA Technologies",
    region: "North America",
    country: "United States",
    flag: us,
    logo: idt,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 71,
    name: "Fahmi Dwilaksono",
    image: fahmi,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "https://www.linkedin.com/in/fahmi-dwilaksono-72373a86/",
  },
  {
    id: 72,
    name: "Muhammad Al Azhar",
    image: muhammad,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 73,
    name: "Mochammad Isro Alfajri",
    image: mochammad,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 74,
    name: "Rian Adha Ardinata",
    image: rian,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 75,
    name: "Adelia Elviantari",
    image: adelia,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 76,
    name: "Indah Nurulita",
    image: indah,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 77,
    name: "Cindy Suci Ananda",
    image: cindy,
    title: "iGEM Alumni",
    filters: ["Alumni"],
    organization: "Sumbawagen 2014",
    region: "Asia",
    country: "Indonesia",
    flag: indonesia,
    logo: alumni,
    sessionId: "",
    linkedIn: "",
  },
  {
    id: 78,
    name: "Ronit Langer",
    image: ronit,
    title: "iGEM Phoenix Project Manager",
    filters: ["Alumni", "iGEM Staff"],
    organization: "After iGEM",
    region: "North America",
    country: "United States",
    flag: us,
    logo: igem_white,
    sessionId: "",
    linkedIn: "",
  },
];
